var func = {
    esRomano: function(datos){///// I
        let valor = (datos.which);
        if (valor !== 105 && valor !== 73) {
            datos.preventDefault();
        }
    },

    esLetra: function(datos){/////[A-Z] con espacio, Ñ . - y acentos
        let valor = (datos.which);
        if(((valor < 97 || valor > 122) && (valor < 65 || valor > 90)) && (valor !== 32 && valor !== 46 && valor !== 241 && valor !== 209) && (valor !==45)
            && (valor !== 225 && valor !== 233 && valor !== 237 && valor !== 243 && valor !== 250)){
            datos.preventDefault();
        }
    },

    esNumero: function(datos){///[0-9] 
        let valor = (datos.which);
        if((valor < 48 || valor > 57)){
            datos.preventDefault();
        }
    },

    FechaDDMMAAAA: function(fecha){ //formatea datetime a DD/MM/AAAA
        fecha = String(fecha);
        return fecha.substr(8, 2) + "/" + fecha.substr(5, 2) + "/" + fecha.substr(0, 4)
    },

    FechaExcel: function(fecha){
        fecha = String(fecha);
        return fecha.substr(8, 2) + "-" + fecha.substr(5, 2) + "-" + fecha.substr(0, 4)
    },

   
    esDireccion: function(datos){/////[A-Z] con espacio, Ñ . # 0-9 y -   ASCII
        let valor = (datos.which);
        if(((valor < 97 || valor > 122) && (valor < 65 || valor > 90)) 
            && (valor !== 32 && valor !== 46 && valor !== 241 && valor !== 209) && (valor !== 35) && (valor < 48 || valor > 57) && (valor !== 45)  ){
            datos.preventDefault();
        }
    }

    

};

export default func;




// WEBPACK FOOTER //
// ./src/components/REGOP/Comun/Funciones/comun.js